import { useEffect, useRef, useState } from 'react';
type CanvasSizeT = {
  width: number;
  height: number;
};
export function useCanvasSize() {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [canvasSize, setCanvasSize] = useState<CanvasSizeT | null>(null);
  useEffect(() => {
    const element = wrapperRef.current;
    if (!element) return;
    const observer = new ResizeObserver(entries => {
      const {
        width,
        height
      } = entries[0]?.contentRect ?? {
        width: 0,
        height: 0
      };
      setCanvasSize({
        width: Math.round(width),
        height: Math.round(height)
      });
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return {
    wrapperRef,
    canvasSize
  };
}